// Hide duplicate "Last Chance Boutique Finds" collection
// More aggressive approach

(function() {
  if (!document.body.classList.contains('template-list-collections')) {
    return;
  }

  function hideDuplicate() {
    // Find all items with the specific image
    const allItems = document.querySelectorAll('.collection-list__item, li.grid__item');
    let foundItems = [];
    
    allItems.forEach(function(item) {
      const img = item.querySelector('img[src*="Untitled_design.png"]');
      const link = item.querySelector('a[href="/collections/last-chance-boutique-finds"]');
      
      if (img || link) {
        foundItems.push(item);
      }
    });
    
    // Hide the first one, keep the second
    if (foundItems.length >= 2) {
      foundItems[0].style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; width: 0 !important; margin: 0 !important; padding: 0 !important; overflow: hidden !important; position: absolute !important; left: -9999px !important;';
      console.log('Hidden first Last Chance Boutique Finds');
    } else if (foundItems.length === 1) {
      // If only one found, check by link
      allItems.forEach(function(item, index) {
        const links = item.querySelectorAll('a[href="/collections/last-chance-boutique-finds"]');
        if (links.length > 0 && index < allItems.length - 1) {
          // Check if there's another one after this
          for (let i = index + 1; i < allItems.length; i++) {
            const nextLinks = allItems[i].querySelectorAll('a[href*="last-chance-boutique-finds"]');
            if (nextLinks.length > 0) {
              // Hide the current one
              item.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; width: 0 !important; margin: 0 !important; padding: 0 !important; overflow: hidden !important; position: absolute !important; left: -9999px !important;';
              console.log('Hidden duplicate by link comparison');
              break;
            }
          }
        }
      });
    }
  }

  // Run multiple times to ensure it catches everything
  hideDuplicate();
  setTimeout(hideDuplicate, 100);
  setTimeout(hideDuplicate, 500);
  setTimeout(hideDuplicate, 1000);
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideDuplicate);
  }
  
  window.addEventListener('load', hideDuplicate);
})();
